export interface ISub {
  sub100: string
}

const sub: ISub = {
  sub100: '#F9F2DF'
}

export default sub
